// src/App.tsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css'; // Или импортируйте стили глобально в index.tsx
import Dashboard from './components/Dashboard/Dashboard';
import Control from './components/Control/Control';
import Login from './components/Login/Login';
import { AuthProvider } from './auth/AuthContext';
import RequireAuth from './auth/RequireAuth';
//import ZenohDemo  from './components/ZenohDemo';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<RequireAuth><Dashboard /></RequireAuth>} />
            <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
            <Route path="/control/:robotId" element={<RequireAuth><Control /></RequireAuth>} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
};

export default App;
